import { Button, BUTTONTYPE } from "src/components/atoms/Button";
import { Logo } from "src/components/atoms/Logo";
import { SearchInput } from "src/components/atoms/SearchInput";
import { BalanceInfo } from "src/components/molecules/BalanceInfo";
import { FavoriteItem } from "src/components/molecules/FavoriteItem";
import PlusIcon from "src/assets/icons/plus.svg";
import styles from "src/components/organisms/AuthHeader/styles.module.css";
import { msg } from "src/i18n/Msg";
import { useIntl } from "react-intl";
import { User } from "src/components/molecules/User";
import { useRedirect } from "src/navigation/useRedirect";
import { MODALS, PAGES } from "src/types/navigation";
import cx from "classnames";
import { NotificationDropdown } from "src/components/organisms/NotificationDropdown";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "src/store";
import { setSearchEvent, setSearchValue } from "src/store/events/eventsSlice";
import { useEffect, useMemo } from "react";
import { debounce } from "lodash";
import { useLocation } from "react-router-dom";
import { isTelegramWebApp } from "src/utils/telegramWebApp";

type Props = {
  openDepositModal?: () => void;
  openEventModal?: () => void;
  openOnboardingModal?: () => void;
};

export const AuthHeader: React.FC<Props> = ({
  openDepositModal,
  openEventModal,
  openOnboardingModal,
}) => {
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const isNottRootPage = pathname !== PAGES.ROOT;
  const isTablet = window.innerWidth === 1162
  const intl = useIntl();
  const { redirect, openModal } = useRedirect();
  const handleNavigateFavorites = () => redirect({ scheme: PAGES.FAVORITES });
  const user = useSelector((state: RootState) => state.profile.user);
  const searchValue = useSelector(
    (state: RootState) => state.events.seacrhValue
  );
  const isLoggined = user?.id;
  const params = new URLSearchParams(window.location.search);
  const isTgVersion = params.get("tg") === "1" || isTelegramWebApp();

  const debounceSearch = useMemo(
    () =>
      debounce((value: string) => {
        dispatch(setSearchEvent(value));
      }, 1000),
    [dispatch]
  );

  useEffect(() => () => debounceSearch.cancel(), [debounceSearch]);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    dispatch(setSearchValue(value));
    debounceSearch(value);
    if (isNottRootPage) {
      redirect({ scheme: PAGES.ROOT }, { state: { search: value } });
    }
  };
  useEffect(() => {
    if (pathname === PAGES.ROOT && searchValue !== "") {
      dispatch(setSearchEvent(searchValue));
    }
  }, [pathname]);

  return (
    <header className={styles.header}>
      <div className={styles.logoContainer}>
        <Logo />
        <div
          className={cx(styles.searchWraper, {
            [styles.loginSearchWraper]: !isLoggined,
          })}
        >
          <SearchInput
            value={searchValue}
            placeholder={msg(intl, {
              id: isTablet ? "components.organisms.AuthHeader.searchTablet":"components.organisms.AuthHeader.search",
            })}
            onChange={handleSearchChange}
          />
        </div>
      </div>
        {isLoggined ? (
          <div className={styles.infoContainer}>
            <FavoriteItem onClick={handleNavigateFavorites} />
            <BalanceInfo
              balance={Number(user?.balance?.available)}
              total={Number(user?.balance?.reserved) ?? 0}
            />
            <Button
              text={{ id: "components.organisms.AuthHeader.addEvenet" }}
              leftIcon={PlusIcon}
              onClick={openEventModal}
              className={styles.addEventBtn}
            />
            <Button
              text={{ id: "components.organisms.AuthHeader.deposit" }}
              onClick={openDepositModal}
              className={styles.depositBtn}
            />
            <NotificationDropdown />
            <User openOnboardingModal={openOnboardingModal} />
          </div>
        ) : !isTgVersion ? (
          <div className={styles.loginBtns}>
            <Button
              btnType={BUTTONTYPE.LIGHT}
              onClick={() => openModal({ scheme: MODALS.SIGN_IN })}
              text={{ id: "components.organisms.AuthHeader.login" }}
            />
            <Button
              text={{ id: "components.organisms.AuthHeader.register" }}
              onClick={() => openModal({ scheme: MODALS.SIGN_UP })}
            />
          </div>
        ) : null}
    </header>
  );
};
